var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',{attrs:{"color":_vm.color,"left":_vm.left,"right":_vm.right,"disabled":_vm.disabled,"iconName":"mdi-delete","isCheckRole":""},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }